"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rowPerPageIntl = exports.createPaginationIntl = void 0;
var R = __importStar(require("../../utils/ramda"));
var createPaginationIntl = function (numberOfRows, intl) {
  var _a;
  var formatMessage = (_a = intl === null || intl === void 0 ? void 0 : intl.formatMessage) !== null && _a !== void 0 ? _a : R.prop("defaultMessage");
  return {
    totalRecords: formatMessage({
      id: "VSX.Pagination.totalRecords",
      defaultMessage: "{0} total records"
    }, {
      0: numberOfRows
    })
  };
};
exports.createPaginationIntl = createPaginationIntl;
var rowPerPageIntl = function (numberOfRowsPerPage, intl) {
  var _a;
  var formatMessage = (_a = intl === null || intl === void 0 ? void 0 : intl.formatMessage) !== null && _a !== void 0 ? _a : R.prop("defaultMessage");
  return formatMessage({
    id: "VSX.Pagination.perPage",
    defaultMessage: "{0} per page"
  }, {
    0: numberOfRowsPerPage
  });
};
exports.rowPerPageIntl = rowPerPageIntl;